import type { CoreProductResponseList, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

export type GetAllProductsOptions = {
  q?: string
  limit?: number
  offset?: number
  order?: 'asc' | 'desc'
  sort?: 'id' | 'title' | 'price_cents' | 'booking_cost_cents' | 'created_at'
  status?: 'enabled' | 'disabled' | 'drafting'
  on_store?: boolean
  bundle?: boolean
  ids?: ParameterID[]
}

/**
 * Get all logged user products.
 *
 * @endpoint GET /api/saas/me/products
 * @scope saas
 * @see https://flecto.dev/api-16895670
 */
export async function getAllProducts(
  insurable?: boolean,
  options: GetAllProductsOptions = {
    offset: 0,
    limit: 10000,
  }
): Promise<CoreProductResponseList> {
  const query = insurable ? { ...options, insurable: true } : options

  const response = await api.get('/api/saas/me/products', {
    params: query,
  })

  return response.data
}
